<section class="cookie-container" [ngClass]="{ hidden: hidden() }" aria-label="Cookie notice">
    <button type="button" class="cookie-container__close-button" aria-label="Close cookie notice" (click)="onClose()">
        <mat-icon svgIcon="ico_close" aria-hidden="true"></mat-icon>
    </button>
    <p class="body-1 cookie-container__text">
        We use cookies on our website to give you the most relevant experience by remembering your preferences and
        repeat visits.
    </p>
</section>
